const DISPLAY_CHARTS =[
    {"title":"Traded Contract", "chartKey":"tradeContractClosePrice"},
    {"title":"SPX", "chartKey":"spxClose"},
    {"title":"Credit Spread", "chartKey":"spreadAtClose"},
    {"title":"Equity Spread", "chartKey":"indexSpreadClose"},
    {"title":"HYG", "chartKey":"hygClose"},
    {"title":"MicroMini", "chartKey":"microMiniClose"},
    {"title":"IEF", "chartKey":"iefClose"},
    {"title":"SPY", "chartKey":"spyClose"},
    {"title":"NDX", "chartKey":"ndxClose"}
]



export {DISPLAY_CHARTS};